import { Component, signal } from '@angular/core';

import { ButtonComponent, CamOverlayPanelComponent, CamStatusSelectComponent } from '@camelot/ui';
import { EditFieldComponent } from '@camelot/form-basic';
import { InputBase, InputTextBox } from '@camelot/form-model';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [ButtonComponent, CamOverlayPanelComponent, CamStatusSelectComponent, EditFieldComponent, TestIdDirective],
    template: `
    <cam-button camTestId="it-button" (action)="this.increment()">Click me</cam-button>
    <div camTestId="it-button-clicks">{{ this.clicks() }}</div>

    <cam-overlay-panel camTestId="it-overlay-panel" [panelConfig]="this.panelConfig">
      <ng-template #panelTrigger>
        <button camTestId="it-overlay-trigger">open panel</button>
      </ng-template>
      <ng-template #panelContent>
        <div camTestId="it-overlay-content">overlay panel content</div>
      </ng-template>
    </cam-overlay-panel>

    <cam-status-select camTestId="it-status-select" label="Open" icon="edit">
      <ng-template #statusMenu>
        <div camTestId="it-status-menu-content">status menu content</div>
      </ng-template>
    </cam-status-select>

    <cam-edit-field camTestId="it-edit-field" [getInput]="this.getInput" />
  `
})
export class UiInteractionsCase {
  public clicks = signal(0);
  public panelConfig = { matchTriggerWidth: false };

  public getInput = (): InputBase<any> => new InputTextBox({ key: 'edit', label: 'Edit me', value: 'initial value' });

  public increment(): void {
    this.clicks.update(count => count + 1);
  }
}
